import { render, staticRenderFns } from "./admissionsUser.vue?vue&type=template&id=0f232020&scoped=true"
import script from "./admissionsUser.vue?vue&type=script&lang=js"
export * from "./admissionsUser.vue?vue&type=script&lang=js"
import style0 from "./admissionsUser.vue?vue&type=style&index=0&id=0f232020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f232020",
  null
  
)

export default component.exports